export default {
    name: "StyledButton",
    template: `
    <input
        type="button"
        class="btn"
        v-on="{ ...$listeners }"
    >
    `
}